// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "Loom.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.OrganisationBO_Res_ASSOC_Bank_BankAccount_Bank = null;
this.OrganisationBO_Res_ASSOC_Person_OrganizationalAffiliation_CreatedBy = null;
this.Res_ENUM_LegalEntityStatus_NaturalPerson = null;
this.Res_ENUM_LegalEntityStatus_LegalPerson = null;
this.Res_ENUM_LegalEntityType_PublicBody = null;
this.Res_ENUM_LegalEntityType_PrivateEntity = null;
this.Res_ENUM_LegalEntityQualification_ForProfit = null;
this.Res_ENUM_LegalEntityQualification_NotForProfit = null;
this.Res_ENUM_FacilityType_Building = null;
this.Res_ENUM_FacilityType_Office = null;
this.Res_ENUM_FacilityType_MeetingRoom = null;
this.ProjectBO_Res_ASSOC_Organisation_ParticipationAsBeneficiary_ProjectParticipant_Organisation = null;
this.ProjectBO_Res_ASSOC_DisseminationLevel_Deliverable_DisseminationLevel = null;
this.ProjectBO_Res_ASSOC_DeliverableType_Deliverable_DeliverableType = null;
this.ProjectBO_Res_ASSOC_Employee_ProjectsMemberships_ProjectTeamMember_Employee = null;
this.ProjectBO_Res_ASSOC_Person_Project_CreatedBy = null;
this.ProjectBO_Res_ASSOC_Competency_ParticipantWorkAssignment_NeededCompetencies = null;
this.Res_ENUM_ProjectTeamMemberRole_Sponsor = null;
this.Res_ENUM_ProjectTeamMemberRole_ProjectManager = null;
this.Res_ENUM_ProjectTeamMemberRole_TechnicalLead = null;
this.Res_ENUM_ProjectTeamMemberRole_Researcher = null;
this.Res_ENUM_ProjectTeamMemberRole_SoftwareEngineer = null;
this.Res_ENUM_ProjectTeamMemberRole_Administration = null;
this.Res_ENUM_ProjectTeamMemberRole_Financial = null;
this.Res_ENUM_ProjectTeamMemberRole_Other = null;
this.Res_ENUM_BeneficiaryRole_Coordinator = null;
this.Res_ENUM_BeneficiaryRole_Beneficiary = null;
this.Res_ENUM_BeneficiaryRole_AffiliatedEntity = null;
this.Res_ENUM_BeneficiaryRole_AssociatedPartner = null;
this.Res_ENUM_LoomMessageType_DEBUG = null;
this.Res_ENUM_LoomMessageType_INFO = null;
this.Res_ENUM_LoomMessageType_WARN = null;
this.Res_ENUM_LoomMessageType_ERROR = null;
this.Res_ENUM_ProjectContractTypes_GrantAgreement = null;
this.Res_ENUM_ProjectContractTypes_Amendment = null;
this.Res_ENUM_IndirectCostsBaseEnum_ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING = null;
this.Res_ENUM_IndirectCostsBaseEnum_ALL_ELIGIBLE_DIRECT_COSTS = null;
this.Res_ENUM_IndirectCostsBaseEnum_ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY = null;
this.ProjectBO_RES_CUSTOM_UploadFileFirst = null;
this.ProjectBO_RES_CUSTOM_CouldNotFindPath = null;
this.ProjectBO_RES_CUSTOM_NotCSVFile = null;
this.Country_Res_ASSOC_Currency_Country_Currencies = null;
this.Country_Res_ASSOC_Country_Cities_City_Country = null;
this.Res_ENUM_SubRegion_None = null;
this.Res_ENUM_SubRegion_NorthernEurope = null;
this.Res_ENUM_SubRegion_WesternEurope = null;
this.Res_ENUM_SubRegion_SouthernEurope = null;
this.Res_ENUM_SubRegion_EasternEurope = null;
this.Res_ENUM_SubRegion_CentralAmerica = null;
this.Res_ENUM_SubRegion_NorthAmerica = null;
this.Res_ENUM_SubRegion_SouthAmerica = null;
this.Res_ENUM_SubRegion_EasternAfrica = null;
this.Res_ENUM_SubRegion_MiddleAfrica = null;
this.Res_ENUM_SubRegion_NorthernAfrica = null;
this.Res_ENUM_SubRegion_SouthernAfrica = null;
this.Res_ENUM_SubRegion_WesternAfrica = null;
this.Res_ENUM_SubRegion_CentralAsia = null;
this.Res_ENUM_SubRegion_EasternAsia = null;
this.Res_ENUM_SubRegion_SouthernAsia = null;
this.Res_ENUM_SubRegion_SouthEasternAsia = null;
this.Res_ENUM_SubRegion_WesternAsia = null;
this.Res_ENUM_SubRegion_AustraliaAndNewZealand = null;
this.Res_ENUM_SubRegion_Melanesia = null;
this.Res_ENUM_SubRegion_Polynesia = null;
this.Res_ENUM_SubRegion_Micronesia = null;
this.Res_ENUM_SubRegion_Caribbean = null;
this.Res_ENUM_Region_None = null;
this.Res_ENUM_Region_Europe = null;
this.Res_ENUM_Region_Americas = null;
this.Res_ENUM_Region_Asia = null;
this.Res_ENUM_Region_Africa = null;
this.Res_ENUM_Region_Oceania = null;
this.Res_ENUM_Region_Antarctic = null;
this.CostStatement_Res_ASSOC_ProjectParticipant_CostStatement_ProjectParticipant = null;
this.CostStatement_Res_ASSOC_ReportingPeriod_CostStatement_ReportingPeriod = null;
this.CostStatement_Res_ASSOC_Project_CostStatement_Project = null;
this.CostStatement_Res_ASSOC_ProjectTask_SubcontractingCostDetail_RelevantTask = null;
this.CostStatement_Res_ASSOC_ProjectTask_ODC_Equipment_RelevantTask = null;
this.CostStatement_Res_ASSOC_ProjectTask_ODC_OtherGoods_RelevantTask = null;
this.CostStatement_Res_ASSOC_Person_CostStatement_LastModifiedBy = null;
this.CostStatement_Res_ASSOC_Person_CostStatement_CreatedBy = null;
this.CostStatement_Res_ASSOC_WorkPackage_CostStatementEffortDetail_WorkPackage = null;
this.Res_ENUM_CostStatementStatusEnum_Draft = null;
this.Res_ENUM_CostStatementStatusEnum_Submitted = null;
this.Res_ENUM_CostStatementStatusEnum_Approved = null;
this.Res_ENUM_CostStatementStatusEnum_Rejected = null;
this.Res_ENUM_ECPersonnelCostsCategories_A1A2A3_ActualCosts = null;
this.Res_ENUM_ECPersonnelCostsCategories_A1A2A3_UnitCosts = null;
this.Res_ENUM_ECPersonnelCostsCategories_A4_UnitCosts = null;
this.Expenses_Res_ASSOC_Trip_ExpenseReports_ExpenseReport_Trip = null;
this.Res_ENUM_ExpenseReportStatus_Draft = null;
this.Res_ENUM_ExpenseReportStatus_Submitted = null;
this.Res_ENUM_ExpenseReportStatus_Approved = null;
this.Res_ENUM_ExpenseReportStatus_Rejected = null;
this.Res_ENUM_ExpenseReportStatus_Canceled = null;
this.Res_ENUM_ExpenseReportStatus_Reimbursed = null;
this.Meeting_Res_ASSOC_ProjectReview_Meeting_Meeting_ProjectReview = null;
this.Meeting_Res_ASSOC_Person_Meeting_CreatedBy = null;
this.Meeting_Res_ASSOC_Employee_MeetingAttendee_Attendee = null;
this.Res_ENUM_MeetingType_Review = null;
this.Res_ENUM_MeetingType_GeneralAssembly = null;
this.Res_ENUM_MeetingType_Workshop = null;
this.Res_ENUM_MeetingType_SteeringCommittee = null;
this.Res_ENUM_MeetingType_AdvisoryBoard = null;
this.Res_ENUM_MeetingType_Other = null;
this.Res_ENUM_MeetingMode_Physical = null;
this.Res_ENUM_MeetingMode_Online = null;
this.Res_ENUM_MeetingMode_Hybrid = null;
this.EmployeeBO_Res_ASSOC_Person_EmploymentRelationships_Employee_Person = null;
this.EmployeeBO_Res_ASSOC_Organisation_EmploymentRelationships_Employee_Organisation = null;
this.EmployeeBO_Res_ASSOC_EmploymentType_EmploymentContract_EmploymentType = null;
this.EmployeeBO_Res_ASSOC_Country_InvoicingEntity_Country = null;
this.Res_ENUM_ECCostCalculationTypes_ActualCosts = null;
this.Res_ENUM_ECCostCalculationTypes_UnitCosts = null;
this.Res_ENUM_ECCostCalculationTypes_HourlyRate = null;
this.Res_ENUM_ECCostCalculationTypes_TimeAndMaterial = null;
this.Res_ENUM_ECCostCalculationTypes_NA = null;
this.LeavesBO_Res_ASSOC_Country_LeavePolicy_Country = null;
this.LeavesBO_Res_ASSOC_TypeOfLeave_LeavePolicy_TypeOfLeave = null;
this.LeavesBO_Res_ASSOC_Person_LeaveRequests_LeaveRequest_Person = null;
this.LeavesBO_Res_ASSOC_Person_LeaveApproval_Approver = null;
this.LeavesBO_Res_ASSOC_LeavePolicy_LeaveBalance_Policy = null;
this.LeavesBO_Res_ASSOC_LeaveBalance_LeaveRequest_LeaveBalance = null;
this.Res_ENUM_LeaveRequestStatus_Pending = null;
this.Res_ENUM_LeaveRequestStatus_Approved = null;
this.Res_ENUM_LeaveRequestStatus_Rejected = null;
this.Res_ENUM_LeaveRequestStatus_Withdrawn = null;
this.Res_ENUM_LeaveRequestStatus_GatheringApprovals = null;
this.Res_ENUM_LeaveDayPortion_FullDay = null;
this.Res_ENUM_LeaveDayPortion_FirstHalfAM = null;
this.Res_ENUM_LeaveDayPortion_SecondHalfPM = null;
this.PersonBO_Res_ASSOC_Person_Person_CreatedBy = null;
this.PersonBO_Res_ASSOC_Person_TeamsCreated_Team_CreatedBy = null;
this.PersonBO_Res_ASSOC_Organisation_PersonOrgAffiliation_AffiliatedOrg = null;
this.PersonBO_Res_ASSOC_Competency_Person_Competencies = null;
this.Res_ENUM_Genders_Male = null;
this.Res_ENUM_Genders_Female = null;
this.Res_ENUM_Genders_NonBinary = null;
this.Res_ENUM_Genders_PreferNottoSay = null;
this.Res_ENUM_Genders_Other = null;
this.Res_ENUM_RelationshipType_Parent = null;
this.Res_ENUM_RelationshipType_Child = null;
this.Res_ENUM_RelationshipType_Spouse = null;
this.Res_ENUM_RelationshipType_Partner = null;
this.Res_ENUM_RelationshipType_Other = null;
this.Res_ENUM_MaritalStatus_Single = null;
this.Res_ENUM_MaritalStatus_Married = null;
this.Res_ENUM_MaritalStatus_Divorced = null;
this.Res_ENUM_MaritalStatus_Separated = null;
this.Res_ENUM_Day_Sunday = null;
this.Res_ENUM_Day_Monday = null;
this.Res_ENUM_Day_Tuesday = null;
this.Res_ENUM_Day_Wednesday = null;
this.Res_ENUM_Day_Thursday = null;
this.Res_ENUM_Day_Friday = null;
this.Res_ENUM_Day_Saturday = null;
this.Res_ENUM_WeekInterval_Both = null;
this.Res_ENUM_WeekInterval_Even = null;
this.Res_ENUM_WeekInterval_Odd = null;
this.TimesheetsBO_Res_ASSOC_EmploymentContract_Timesheet_EmploymentContract = null;
this.TimesheetsBO_Res_ASSOC_WorkPackage_TimesheetEntry_WorkPackage = null;
this.TimesheetsBO_Res_ASSOC_Person_Timesheet_ApprovedBy = null;
this.Res_ENUM_TimesheetStatus_Draft = null;
this.Res_ENUM_TimesheetStatus_Submitted = null;
this.Res_ENUM_TimesheetStatus_Approved = null;
this.Res_ENUM_TimesheetStatus_Rejected = null;
this.Res_ENUM_BooleanNullable_Null = null;
this.Res_ENUM_BooleanNullable_True = null;
this.Res_ENUM_BooleanNullable_False = null;
this.ForecastsBO_Res_ASSOC_EmploymentContract_MonthlyEmployeeForecast_Employee = null;
this.ProjectPlanningBO_Res_ASSOC_Organisation_ProjectPlans_ProjectPlan_Organisation = null;
this.ProjectPlanningBO_Res_ASSOC_Project_AssignedResource_Project = null;
this.ProjectPlanningBO_Res_ASSOC_Person_ProjectPlan_ModifiedBy = null;
this.ProjectPlanningBO_Res_ASSOC_Project_PlanPerProjectCostSummary_Project = null;
this.ProjectPlanningBO_Res_ASSOC_Employee_AssignedResource_Employee = null;
this.TripsBO_Res_ASSOC_Project_Trips_Trip_Project = null;
this.TripsBO_Res_ASSOC_Meeting_Trips_Trip_Meeting = null;
this.TripsBO_Res_ASSOC_Person_Trip_CreatedBy = null;
this.TripsBO_Res_ASSOC_Person_TripApproval_Approver = null;
this.TripsBO_Res_ASSOC_Employee_TripTraveller_Employee = null;
this.TripsBO_Res_ASSOC_ProjectParticipant_Trips_Trip_Beneficiary = null;
this.Res_ENUM_TripStatus_Draft = null;
this.Res_ENUM_TripStatus_PendingApproval = null;
this.Res_ENUM_TripStatus_Approved = null;
this.Res_ENUM_TripStatus_Booked = null;
this.Res_ENUM_TripStatus_InProgress = null;
this.Res_ENUM_TripStatus_Completed = null;
this.Res_ENUM_TripStatus_Cancelled = null;
this.Res_ENUM_TripStatus_Rejected = null;
this.Res_ENUM_TripStatus_Closed = null;
this.CostReportingBO_Res_ASSOC_ReportingPeriod_ProjectPersonnelClaimsEmployeeSummary_ProjectReportingPeriod = null;
this.Res_ENUM_DailyRateCalculationMethod_ActualCostsHEUPerCalendarYear = null;
this.Res_ENUM_DailyRateCalculationMethod_ActualCostsHEUPerPeriod = null;
this.Res_ENUM_DailyRateCalculationMethod_ActualCostsH2020 = null;
this.ProjectManagementBO_Res_ASSOC_Employee_TimeEntry_Employee = null;
this.EUProgrammeBO_Res_ASSOC_Country_CorrectionCoefficient_Country = null;
this.IssuesBO_Res_ASSOC_FileData_Issue_Attachments = null;
this.Res_ENUM_IssueStatuses_New = null;
this.Res_ENUM_IssueStatuses_InProgress = null;
this.Res_ENUM_IssueStatuses_Resolved = null;
this.Res_ENUM_IssueStatuses_Dropped = null;
this.Res_ENUM_IssueStatuses_Closed = null;
this.Res_ENUM_IssueTypes_BugReport = null;
this.Res_ENUM_IssueTypes_Performance = null;
this.Res_ENUM_IssueTypes_Security = null;
this.Res_ENUM_IssueTypes_LoginProblem = null;
this.Res_ENUM_IssueTypes_Account = null;
this.Res_ENUM_IssueTypes_Usability = null;
this.Res_ENUM_IssueTypes_FeatureRequest = null;
this.Res_ENUM_IssueTypes_IncorrectInformation = null;
this.Res_ENUM_IssueTypes_HowTo = null;
this.Res_ENUM_IssueTypes_Other = null;
this.Res_ENUM_CalendarVisibility_Restricted = null;
this.Res_ENUM_CalendarVisibility_Private = null;
this.Res_ENUM_CalendarVisibility_Public = null;
this.PayrollDataBO_Res_ASSOC_BenefitType_EmployeeBenefit_Type = null;
this.Res_ENUM_BenefitFrequency_Monthly = null;
this.Res_ENUM_BenefitFrequency_Annual = null;
this.Res_ENUM_BenefitFrequency_OneTime = null;
this.Res_ENUM_EmployeePaymentType_Salary = null;
this.Res_ENUM_EmployeePaymentType_Benefit = null;
this.Res_ENUM_PayrollPeriod_Regular = null;
this.Res_ENUM_PayrollPeriod_EasterBonus = null;
this.Res_ENUM_PayrollPeriod_ChristmasBonus = null;
this.Res_ENUM_PayrollPeriod_HolidayAllowance = null;
this.Res_ENUM_PayrollPeriod_TerminationCompensation = null;
this.Res_ENUM_TaxType_Percentage = null;
this.Res_ENUM_TaxType_Fixed = null;
}

static translate: TranslateService;
_key: any;
OrganisationBO_Res_ASSOC_Bank_BankAccount_Bank:any;
OrganisationBO_Res_ASSOC_Person_OrganizationalAffiliation_CreatedBy:any;
Res_ENUM_LegalEntityStatus_NaturalPerson:any;
Res_ENUM_LegalEntityStatus_LegalPerson:any;
Res_ENUM_LegalEntityType_PublicBody:any;
Res_ENUM_LegalEntityType_PrivateEntity:any;
Res_ENUM_LegalEntityQualification_ForProfit:any;
Res_ENUM_LegalEntityQualification_NotForProfit:any;
Res_ENUM_FacilityType_Building:any;
Res_ENUM_FacilityType_Office:any;
Res_ENUM_FacilityType_MeetingRoom:any;
ProjectBO_Res_ASSOC_Organisation_ParticipationAsBeneficiary_ProjectParticipant_Organisation:any;
ProjectBO_Res_ASSOC_DisseminationLevel_Deliverable_DisseminationLevel:any;
ProjectBO_Res_ASSOC_DeliverableType_Deliverable_DeliverableType:any;
ProjectBO_Res_ASSOC_Employee_ProjectsMemberships_ProjectTeamMember_Employee:any;
ProjectBO_Res_ASSOC_Person_Project_CreatedBy:any;
ProjectBO_Res_ASSOC_Competency_ParticipantWorkAssignment_NeededCompetencies:any;
Res_ENUM_ProjectTeamMemberRole_Sponsor:any;
Res_ENUM_ProjectTeamMemberRole_ProjectManager:any;
Res_ENUM_ProjectTeamMemberRole_TechnicalLead:any;
Res_ENUM_ProjectTeamMemberRole_Researcher:any;
Res_ENUM_ProjectTeamMemberRole_SoftwareEngineer:any;
Res_ENUM_ProjectTeamMemberRole_Administration:any;
Res_ENUM_ProjectTeamMemberRole_Financial:any;
Res_ENUM_ProjectTeamMemberRole_Other:any;
Res_ENUM_BeneficiaryRole_Coordinator:any;
Res_ENUM_BeneficiaryRole_Beneficiary:any;
Res_ENUM_BeneficiaryRole_AffiliatedEntity:any;
Res_ENUM_BeneficiaryRole_AssociatedPartner:any;
Res_ENUM_LoomMessageType_DEBUG:any;
Res_ENUM_LoomMessageType_INFO:any;
Res_ENUM_LoomMessageType_WARN:any;
Res_ENUM_LoomMessageType_ERROR:any;
Res_ENUM_ProjectContractTypes_GrantAgreement:any;
Res_ENUM_ProjectContractTypes_Amendment:any;
Res_ENUM_IndirectCostsBaseEnum_ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING:any;
Res_ENUM_IndirectCostsBaseEnum_ALL_ELIGIBLE_DIRECT_COSTS:any;
Res_ENUM_IndirectCostsBaseEnum_ELIGIBLE_DIRECT_COSTS_EXCL_SUBCONTRACTING_AND_3RD_PARTY:any;
ProjectBO_RES_CUSTOM_UploadFileFirst:any;
ProjectBO_RES_CUSTOM_CouldNotFindPath:any;
ProjectBO_RES_CUSTOM_NotCSVFile:any;
Country_Res_ASSOC_Currency_Country_Currencies:any;
Country_Res_ASSOC_Country_Cities_City_Country:any;
Res_ENUM_SubRegion_None:any;
Res_ENUM_SubRegion_NorthernEurope:any;
Res_ENUM_SubRegion_WesternEurope:any;
Res_ENUM_SubRegion_SouthernEurope:any;
Res_ENUM_SubRegion_EasternEurope:any;
Res_ENUM_SubRegion_CentralAmerica:any;
Res_ENUM_SubRegion_NorthAmerica:any;
Res_ENUM_SubRegion_SouthAmerica:any;
Res_ENUM_SubRegion_EasternAfrica:any;
Res_ENUM_SubRegion_MiddleAfrica:any;
Res_ENUM_SubRegion_NorthernAfrica:any;
Res_ENUM_SubRegion_SouthernAfrica:any;
Res_ENUM_SubRegion_WesternAfrica:any;
Res_ENUM_SubRegion_CentralAsia:any;
Res_ENUM_SubRegion_EasternAsia:any;
Res_ENUM_SubRegion_SouthernAsia:any;
Res_ENUM_SubRegion_SouthEasternAsia:any;
Res_ENUM_SubRegion_WesternAsia:any;
Res_ENUM_SubRegion_AustraliaAndNewZealand:any;
Res_ENUM_SubRegion_Melanesia:any;
Res_ENUM_SubRegion_Polynesia:any;
Res_ENUM_SubRegion_Micronesia:any;
Res_ENUM_SubRegion_Caribbean:any;
Res_ENUM_Region_None:any;
Res_ENUM_Region_Europe:any;
Res_ENUM_Region_Americas:any;
Res_ENUM_Region_Asia:any;
Res_ENUM_Region_Africa:any;
Res_ENUM_Region_Oceania:any;
Res_ENUM_Region_Antarctic:any;
CostStatement_Res_ASSOC_ProjectParticipant_CostStatement_ProjectParticipant:any;
CostStatement_Res_ASSOC_ReportingPeriod_CostStatement_ReportingPeriod:any;
CostStatement_Res_ASSOC_Project_CostStatement_Project:any;
CostStatement_Res_ASSOC_ProjectTask_SubcontractingCostDetail_RelevantTask:any;
CostStatement_Res_ASSOC_ProjectTask_ODC_Equipment_RelevantTask:any;
CostStatement_Res_ASSOC_ProjectTask_ODC_OtherGoods_RelevantTask:any;
CostStatement_Res_ASSOC_Person_CostStatement_LastModifiedBy:any;
CostStatement_Res_ASSOC_Person_CostStatement_CreatedBy:any;
CostStatement_Res_ASSOC_WorkPackage_CostStatementEffortDetail_WorkPackage:any;
Res_ENUM_CostStatementStatusEnum_Draft:any;
Res_ENUM_CostStatementStatusEnum_Submitted:any;
Res_ENUM_CostStatementStatusEnum_Approved:any;
Res_ENUM_CostStatementStatusEnum_Rejected:any;
Res_ENUM_ECPersonnelCostsCategories_A1A2A3_ActualCosts:any;
Res_ENUM_ECPersonnelCostsCategories_A1A2A3_UnitCosts:any;
Res_ENUM_ECPersonnelCostsCategories_A4_UnitCosts:any;
Expenses_Res_ASSOC_Trip_ExpenseReports_ExpenseReport_Trip:any;
Res_ENUM_ExpenseReportStatus_Draft:any;
Res_ENUM_ExpenseReportStatus_Submitted:any;
Res_ENUM_ExpenseReportStatus_Approved:any;
Res_ENUM_ExpenseReportStatus_Rejected:any;
Res_ENUM_ExpenseReportStatus_Canceled:any;
Res_ENUM_ExpenseReportStatus_Reimbursed:any;
Meeting_Res_ASSOC_ProjectReview_Meeting_Meeting_ProjectReview:any;
Meeting_Res_ASSOC_Person_Meeting_CreatedBy:any;
Meeting_Res_ASSOC_Employee_MeetingAttendee_Attendee:any;
Res_ENUM_MeetingType_Review:any;
Res_ENUM_MeetingType_GeneralAssembly:any;
Res_ENUM_MeetingType_Workshop:any;
Res_ENUM_MeetingType_SteeringCommittee:any;
Res_ENUM_MeetingType_AdvisoryBoard:any;
Res_ENUM_MeetingType_Other:any;
Res_ENUM_MeetingMode_Physical:any;
Res_ENUM_MeetingMode_Online:any;
Res_ENUM_MeetingMode_Hybrid:any;
EmployeeBO_Res_ASSOC_Person_EmploymentRelationships_Employee_Person:any;
EmployeeBO_Res_ASSOC_Organisation_EmploymentRelationships_Employee_Organisation:any;
EmployeeBO_Res_ASSOC_EmploymentType_EmploymentContract_EmploymentType:any;
EmployeeBO_Res_ASSOC_Country_InvoicingEntity_Country:any;
Res_ENUM_ECCostCalculationTypes_ActualCosts:any;
Res_ENUM_ECCostCalculationTypes_UnitCosts:any;
Res_ENUM_ECCostCalculationTypes_HourlyRate:any;
Res_ENUM_ECCostCalculationTypes_TimeAndMaterial:any;
Res_ENUM_ECCostCalculationTypes_NA:any;
LeavesBO_Res_ASSOC_Country_LeavePolicy_Country:any;
LeavesBO_Res_ASSOC_TypeOfLeave_LeavePolicy_TypeOfLeave:any;
LeavesBO_Res_ASSOC_Person_LeaveRequests_LeaveRequest_Person:any;
LeavesBO_Res_ASSOC_Person_LeaveApproval_Approver:any;
LeavesBO_Res_ASSOC_LeavePolicy_LeaveBalance_Policy:any;
LeavesBO_Res_ASSOC_LeaveBalance_LeaveRequest_LeaveBalance:any;
Res_ENUM_LeaveRequestStatus_Pending:any;
Res_ENUM_LeaveRequestStatus_Approved:any;
Res_ENUM_LeaveRequestStatus_Rejected:any;
Res_ENUM_LeaveRequestStatus_Withdrawn:any;
Res_ENUM_LeaveRequestStatus_GatheringApprovals:any;
Res_ENUM_LeaveDayPortion_FullDay:any;
Res_ENUM_LeaveDayPortion_FirstHalfAM:any;
Res_ENUM_LeaveDayPortion_SecondHalfPM:any;
PersonBO_Res_ASSOC_Person_Person_CreatedBy:any;
PersonBO_Res_ASSOC_Person_TeamsCreated_Team_CreatedBy:any;
PersonBO_Res_ASSOC_Organisation_PersonOrgAffiliation_AffiliatedOrg:any;
PersonBO_Res_ASSOC_Competency_Person_Competencies:any;
Res_ENUM_Genders_Male:any;
Res_ENUM_Genders_Female:any;
Res_ENUM_Genders_NonBinary:any;
Res_ENUM_Genders_PreferNottoSay:any;
Res_ENUM_Genders_Other:any;
Res_ENUM_RelationshipType_Parent:any;
Res_ENUM_RelationshipType_Child:any;
Res_ENUM_RelationshipType_Spouse:any;
Res_ENUM_RelationshipType_Partner:any;
Res_ENUM_RelationshipType_Other:any;
Res_ENUM_MaritalStatus_Single:any;
Res_ENUM_MaritalStatus_Married:any;
Res_ENUM_MaritalStatus_Divorced:any;
Res_ENUM_MaritalStatus_Separated:any;
Res_ENUM_Day_Sunday:any;
Res_ENUM_Day_Monday:any;
Res_ENUM_Day_Tuesday:any;
Res_ENUM_Day_Wednesday:any;
Res_ENUM_Day_Thursday:any;
Res_ENUM_Day_Friday:any;
Res_ENUM_Day_Saturday:any;
Res_ENUM_WeekInterval_Both:any;
Res_ENUM_WeekInterval_Even:any;
Res_ENUM_WeekInterval_Odd:any;
TimesheetsBO_Res_ASSOC_EmploymentContract_Timesheet_EmploymentContract:any;
TimesheetsBO_Res_ASSOC_WorkPackage_TimesheetEntry_WorkPackage:any;
TimesheetsBO_Res_ASSOC_Person_Timesheet_ApprovedBy:any;
Res_ENUM_TimesheetStatus_Draft:any;
Res_ENUM_TimesheetStatus_Submitted:any;
Res_ENUM_TimesheetStatus_Approved:any;
Res_ENUM_TimesheetStatus_Rejected:any;
Res_ENUM_BooleanNullable_Null:any;
Res_ENUM_BooleanNullable_True:any;
Res_ENUM_BooleanNullable_False:any;
ForecastsBO_Res_ASSOC_EmploymentContract_MonthlyEmployeeForecast_Employee:any;
ProjectPlanningBO_Res_ASSOC_Organisation_ProjectPlans_ProjectPlan_Organisation:any;
ProjectPlanningBO_Res_ASSOC_Project_AssignedResource_Project:any;
ProjectPlanningBO_Res_ASSOC_Person_ProjectPlan_ModifiedBy:any;
ProjectPlanningBO_Res_ASSOC_Project_PlanPerProjectCostSummary_Project:any;
ProjectPlanningBO_Res_ASSOC_Employee_AssignedResource_Employee:any;
TripsBO_Res_ASSOC_Project_Trips_Trip_Project:any;
TripsBO_Res_ASSOC_Meeting_Trips_Trip_Meeting:any;
TripsBO_Res_ASSOC_Person_Trip_CreatedBy:any;
TripsBO_Res_ASSOC_Person_TripApproval_Approver:any;
TripsBO_Res_ASSOC_Employee_TripTraveller_Employee:any;
TripsBO_Res_ASSOC_ProjectParticipant_Trips_Trip_Beneficiary:any;
Res_ENUM_TripStatus_Draft:any;
Res_ENUM_TripStatus_PendingApproval:any;
Res_ENUM_TripStatus_Approved:any;
Res_ENUM_TripStatus_Booked:any;
Res_ENUM_TripStatus_InProgress:any;
Res_ENUM_TripStatus_Completed:any;
Res_ENUM_TripStatus_Cancelled:any;
Res_ENUM_TripStatus_Rejected:any;
Res_ENUM_TripStatus_Closed:any;
CostReportingBO_Res_ASSOC_ReportingPeriod_ProjectPersonnelClaimsEmployeeSummary_ProjectReportingPeriod:any;
Res_ENUM_DailyRateCalculationMethod_ActualCostsHEUPerCalendarYear:any;
Res_ENUM_DailyRateCalculationMethod_ActualCostsHEUPerPeriod:any;
Res_ENUM_DailyRateCalculationMethod_ActualCostsH2020:any;
ProjectManagementBO_Res_ASSOC_Employee_TimeEntry_Employee:any;
EUProgrammeBO_Res_ASSOC_Country_CorrectionCoefficient_Country:any;
IssuesBO_Res_ASSOC_FileData_Issue_Attachments:any;
Res_ENUM_IssueStatuses_New:any;
Res_ENUM_IssueStatuses_InProgress:any;
Res_ENUM_IssueStatuses_Resolved:any;
Res_ENUM_IssueStatuses_Dropped:any;
Res_ENUM_IssueStatuses_Closed:any;
Res_ENUM_IssueTypes_BugReport:any;
Res_ENUM_IssueTypes_Performance:any;
Res_ENUM_IssueTypes_Security:any;
Res_ENUM_IssueTypes_LoginProblem:any;
Res_ENUM_IssueTypes_Account:any;
Res_ENUM_IssueTypes_Usability:any;
Res_ENUM_IssueTypes_FeatureRequest:any;
Res_ENUM_IssueTypes_IncorrectInformation:any;
Res_ENUM_IssueTypes_HowTo:any;
Res_ENUM_IssueTypes_Other:any;
Res_ENUM_CalendarVisibility_Restricted:any;
Res_ENUM_CalendarVisibility_Private:any;
Res_ENUM_CalendarVisibility_Public:any;
PayrollDataBO_Res_ASSOC_BenefitType_EmployeeBenefit_Type:any;
Res_ENUM_BenefitFrequency_Monthly:any;
Res_ENUM_BenefitFrequency_Annual:any;
Res_ENUM_BenefitFrequency_OneTime:any;
Res_ENUM_EmployeePaymentType_Salary:any;
Res_ENUM_EmployeePaymentType_Benefit:any;
Res_ENUM_PayrollPeriod_Regular:any;
Res_ENUM_PayrollPeriod_EasterBonus:any;
Res_ENUM_PayrollPeriod_ChristmasBonus:any;
Res_ENUM_PayrollPeriod_HolidayAllowance:any;
Res_ENUM_PayrollPeriod_TerminationCompensation:any;
Res_ENUM_TaxType_Percentage:any;
Res_ENUM_TaxType_Fixed:any;




}